import { proxyCustomElement, HTMLElement, h, Fragment } from '@stencil/core/internal/client';
import { C as CURRENT_MODULE } from './index2.js';
import { s as state } from './index3.js';
import { d as defineCustomElement$1 } from './button-base2.js';

import { baseCss } from './css.js';
const nlWelcomeCss = baseCss;

const NlWelcomeStyle0 = nlWelcomeCss;

const NlWelcome = /*@__PURE__*/ proxyCustomElement(class NlWelcome extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.titleWelcome = 'Welcome to Nostr!';
        this.description = 'This website is part of the Nostr network. Log in with your Nostr profile or sign up to join.';
    }
    handleChangeScreen(screen) {
        state.path = [...state.path, screen];
    }
    render() {
        return (h(Fragment, { key: '9fbfb07f267912a84a036ab844d3dc3e4fecb2aa' }, h("div", { key: '04b7452fb9481f99e793a3a64b5febd0d644cb70', class: "p-4 overflow-y-auto" }, h("h1", { key: '32ec61d34e5abead821096f50ebfceb65ac06ceb', class: "nl-title font-bold text-center text-4xl" }, this.titleWelcome), h("p", { key: 'fa5272e74078d89100f42a9b0f25c30eb5746460', class: "nl-description font-light text-center text-lg pt-2 max-w-96 mx-auto" }, this.description)), h("div", { key: '9745a35fa223d2481e77258c5f40793174f5cc70', class: "max-w-52 mx-auto pb-5" }, h("div", { key: 'f395ddcb3e75049fde79d0b9bc797e3cef6d4e30', class: "flex gap-3 flex-col mb-2" }, h("button-base", { key: '367ccec38380c93a7ab812436093ce643209ae2e', titleBtn: "Log in", onClick: () => this.handleChangeScreen(CURRENT_MODULE.WELCOME_LOGIN) }, h("svg", { key: 'ce6f3533b3a83145deb79257f68f2e8749122571', style: { display: 'none' }, slot: "icon-start", xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", "stroke-width": "1.5", stroke: "currentColor" }, h("path", { key: '38cc63a69adc25366f4bc78cd966624e4da8234e', "stroke-linecap": "round", "stroke-linejoin": "round", d: "M15.75 5.25a3 3 0 0 1 3 3m3 0a6 6 0 0 1-7.029 5.912c-.563-.097-1.159.026-1.563.43L10.5 17.25H8.25v2.25H6v2.25H2.25v-2.818c0-.597.237-1.17.659-1.591l6.499-6.499c.404-.404.527-1 .43-1.563A6 6 0 1 1 21.75 8.25Z" })))), h("button-base", { key: 'f3bc1f5b2b971a2c25b18b00e83a1e0f66800c05', onClick: () => this.handleChangeScreen(CURRENT_MODULE.WELCOME_SIGNUP), titleBtn: "Sign up" }, h("svg", { key: 'b10cd84902c819733453a9642bd3e28dc4057c04', style: { display: 'none' }, slot: "icon-start", xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", "stroke-width": "1.5", stroke: "currentColor" }, h("path", { key: 'e8e2a4bfdcc92971a44f076a97c0b9043377cbe9', "stroke-linecap": "round", "stroke-linejoin": "round", d: "M18 7.5v3m0 0v3m0-3h3m-3 0h-3m-2.25-4.125a3.375 3.375 0 1 1-6.75 0 3.375 3.375 0 0 1 6.75 0ZM3 19.235v-.11a6.375 6.375 0 0 1 12.75 0v.109A12.318 12.318 0 0 1 9.374 21c-2.331 0-4.512-.645-6.374-1.766Z" }))))));
    }
    static get style() { return NlWelcomeStyle0; }
}, [0, "nl-welcome", {
        "titleWelcome": [1, "title-welcome"],
        "description": [1]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["nl-welcome", "button-base"];
    components.forEach(tagName => { switch (tagName) {
        case "nl-welcome":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, NlWelcome);
            }
            break;
        case "button-base":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}
defineCustomElement();

export { NlWelcome as N, defineCustomElement as d };

//# sourceMappingURL=nl-welcome2.js.map